<template>
  <div id="pdf" class="pdf-content container-fluid">
    <hr>
    <div id="row">
    <img class="logo_leak logo" width="200px" :src="logoUrl">    
    <h4>Evento #{{event && event.id}}</h4>
      <div class="pdf__info">
        <p> <span class="pdf__titles"> Para: </span> A quien corresponda </p>
        <p> <span class="pdf__titles"> De: </span> {{ fromCompany }} </p>
        <p> <span class="pdf__titles"> Fecha: </span> {{event && event.fecha}} </p>
        <p> <span class="pdf__titles"> Ducto: </span> {{event && event.ducto}} </p>
        <p> <span class="pdf__titles"> Tramo: </span> {{event && event.tramo}} </p>        
        <p class="pdf__titles"> Ubicación del evento </p>
        <div style="margin:auto ;display: block; margin-left: auto; margin-right: auto; width: 90%;">
        <img v-if="mapImg" id="img_map" :src="`${mapImg}`" style="max-width:100%; max-height:100%; margin: auto">        
        </div>
        <br>
        <div style="position: relative; max-width: 100%; height: 25vh; padding: 0px; margin: 0px; border-width: 0px; cursor: default;" >
          <img v-for="canvas in chartCanvas" :src="canvas.toDataURL()" style="max-width:100%; max-height:100%; position: absolute; left: 0px; top: 0px; width: 1554px; height: 395px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;" />
        </div>
        <br>
        <table id="tableholder">
          <thead id="header">
            <tr id="trh">
              <th  id="thh" class="title__td">Fecha Evento</th>
              <th  id="thh" class="title__td">Kilometro</th>
              <th id="thh" class="title__td">Latitud</th>
              <th id="thh" class="title__td">Longitud</th>
              <th id="thh" class="title__td">Acción</th>
            </tr>
          </thead>
            <tbody v-if="event">
              <tr id="trw">
                <td id="tdc"> {{event.fecha}} </td>
                <td id="tdc"> {{event.km}} </td>
                <td id="tdc"> {{event.lat}} </td>
                <td id="tdc"> {{event.lng}} </td>
                <td id="tdc"> {{event.tipo === 1 ? 'Apertura' : 'Cierre'}} </td>
              </tr>              
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      click: false,
      pressureChart: null,
      desde: null,
      hasta: null
    }
  },
  props: ['event', 'mapImg', 'chartRage', 'chartCanvas'],
  components: {    
  },
  watch: {
    event() {
      /* this.desde = new Date(this.event.fecha.toString());
      this.hasta = new Date(this.event.fecha.toString());
      this.desde.setTime(this.desde.getTime() - (this.chartRage * 60 * 1000));
      this.hasta.setTime(this.hasta.getTime() + (this.chartRage * 60 * 1000));
      this.desde = moment(this.desde).format('YYYY-MM-DD HH:mm:ss');
      this.hasta = moment(this.hasta).format('YYYY-MM-DD HH:mm:ss'); */
    },
    chartCanvas() {
      
    }
  },
  computed: {
    logoUrl() {
      return require('imgs/logos/Logo_' + process.env.SITE_TYPE + '_V.png');
    },
    fromCompany() {
      return process.env.PDF_FROM;
    }
  },
  mounted() {
    
  },
}
</script>

<style lang="scss" scoped>
@import '~varmix';

  #pdf {
    width: 100%;
    
    .logo_leak{
      width:200px;
      text-align:left;
    }

    .logo_pem{
      width:200px;
      float:right;
    }
    #row {
      padding: 25px;
    }
    img{
      width: 100%;
    }
    hr {
      color: var(--btn-default);
    }

    #imgChart{
      width:100%; 
      margin-top:100px;
    }
    h4 {
      text-align: center;
      text-transform: uppercase;
      color: #000;
    }
    .pdf__info {
      margin: 0 auto;
      display: block;
    }
    .pdf__titles {
      color: var(--btn-default);
    }
        
       div#pdf{
            max-height:200px;
            height:200px;
          }
         div#linechart{
            display:none;
          }
        img#leak{
              display:inline-block;
              width:115px;
            }
        img#pem{
              padding-left: 400px;
              display:inline-block;
              width:115px;
            }
       h4#h41{
              font-size:30px;
              font-weight:400;
              text-transform: uppercase;
              padding:0;
              margin-top:10px;
              margin-bottom:10px;
            }
        hr#hr1{
              	background-color: #fff;
	              border-top: 2px solid var(--btn-default);
            }
       span#titles{
            color: var(--btn-default);
            text-transform: uppercase;
            margin-left:4px;
          }
       #tablecontainer{
            height:440px;
          }
        table#tableholder{
            height: 50%;
            width:100%;
            margin:0;
            text-align:center;
          }
         thead#header{
             width:100%;
             padding:2px;
             background-color:var(--btn-default);
          }
          tr#trh{
             width:100%;
             padding:2px;
             background-color:var(--btn-default);
          }
          th#thh{
             font-size:12pt;
             align:left;
             font-weight:400;
             padding:5px;
             border: 1.5px solid var(--btn-default);
             color:white;
          }
          td#tdc{
             font-size:10pt;
             text-align:left;
             padding:2px;
             border: 1px solid #777777;
          }
  }
</style>



// WEBPACK FOOTER //
// PdfView.vue?4809db2a